import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import '../components/styles/about.css'

const About = () => {
  useEffect(() => {
    const observerCallback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, {
      threshold: 0.1
    });

    document.querySelectorAll('.reveal-on-scroll').forEach(element => {
      observer.observe(element);
    });

    return () => observer.disconnect();
  }, []);

  const styles = {
    portraitContainer: {
      display: 'flex',
      justifyContent: 'center',
      padding: '2rem 0'
    },
    container: {
      position: 'relative',
      width: '300px',
      height: '300px',
      borderRadius: '8px',
      overflow: 'hidden'
    },
    image: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'center'
    }
  };

  return (
    <div className="page-container">
      {/* Hero Section */}
      <div className="hero-section">
        <div className="hero-image-container">
          <img 
            src="/brush18.jpg"
            alt="Makeup artist at work"
          />
          <div className="hero-overlay" />
        </div>
        <div className="hero-content">
          <h1 className="hero-title fade-in">About Me</h1>
        </div>
      </div>

      <div style={styles.portraitContainer}>
        <div style={styles.container}>
          <img
            src="/Lorrenselfie2.jpg"
            alt="Lorren"
            style={styles.image}
          />
        </div>
      </div>

      <div className="main-container">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="grid-container"
        >
          <div className="content-section reveal-on-scroll">
            <h2>Lorren (Head Artist)</h2>
            <h3>Professional Makeup Artist</h3>
            
            <div>
              <p>
                With over 19 years of experience in ERP analysis, business strategy, and operations 
                within the automotive industry, I bring a unique blend of precision, creativity, 
                and problem-solving skills to the art of makeup.
              </p>
              
              <p>
                Throughout my career, I worked closely with cross-functional teams to deliver 
                solutions that meet business needs and enhance user experience. Now, I'm channeling 
                that same attention to detail and passion for collaboration into the world of beauty.
              </p>

              <p>
                As a soon-to-be graduate of the Canadian Beauty College Makeup Diploma program, I am eager to 
                combine my love for creative expression with my expertise in working with people.
              </p>

              <p>
                My journey as a makeup artist is fueled by a desire to connect with others, 
                highlight their natural beauty, and offer personalized, high-quality services 
                for every occasion.
              </p>

              <p>
                Whether you're preparing for a special event, a photoshoot, or just looking to 
                treat yourself, I'm here to bring your vision to life with professionalism, 
                skill, and artistry.
              </p>
            </div>

          <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginTop: '2rem' }}>
              <a href="/booking" style={{ width: '100%', maxWidth: '400px' }}>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="consultation-button"
                  style={{ width: '100%' }}
                >
                  Book a Consultation
                </motion.button>
              </a>
            </div>
          </div>
        </motion.div>

        <div className="skills-section reveal-on-scroll">
          <h2>Skills & Expertise</h2>
          
          <div className="skills-grid">
            {[
              {
                title: "Bridal Makeup",
                description: "Specialized in creating timeless, photogenic looks for your special day"
              },
              {
                title: "Editorial",
                description: "Creative and bold looks for photoshoots and professional media"
              },
              {
                title: "Special Events",
                description: "Glamorous and elegant makeup for any occasion"
              }
            ].map((skill, index) => (
              <div 
                key={index}
                className="skill-card"
              >
                <h3>{skill.title}</h3>
                <p>{skill.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;